export default __webpack_public_path__ + "static/media/aboutBgDec3.3f4ce72f.png";